import { render, staticRenderFns } from "./Privacy_Policy.vue?vue&type=template&id=fcd15496&"
import script from "./Privacy_Policy.vue?vue&type=script&lang=js&"
export * from "./Privacy_Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports